import { CommunicationTemplateSchema, DocumentTemplateSchema, NoteTemplateSchema, TimelineTemplateSchema, } from './aggregates/template.js';
export const isCommunicationTemplate = (template) => CommunicationTemplateSchema.safeParse(template).success;
export const isNoteTemplate = (template) => NoteTemplateSchema.safeParse(template).success;
export const isDocumentTemplate = (template) => DocumentTemplateSchema.safeParse(template).success;
export const isTimelineTemplate = (template) => TimelineTemplateSchema.safeParse(template).success;
